var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default",function(){return [_c('el-cascader',{staticStyle:{"width":"100%"},attrs:{"options":_vm.itemOptions,"props":{
        value: 'Code',
        label: 'Name',
        emitPath: false,
        multiple: _vm.multiple,
      },"collapse-tags":"","clearable":""},on:{"change":_vm.onChange},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})]},{"data":_vm.itemOptions})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }